import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignLeft = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 6C3.22386 6 3 6.22386 3 6.5C3 6.77614 3.22386 7 3.5 7H20.5C20.7761 7 21 6.77614 21 6.5C21 6.22386 20.7761 6 20.5 6H3.5ZM3 12C3 11.7239 3.22386 11.5 3.5 11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5H3.5C3.22386 12.5 3 12.2761 3 12ZM3 17.5C3 17.2239 3.22386 17 3.5 17H12.5C12.7761 17 13 17.2239 13 17.5C13 17.7761 12.7761 18 12.5 18H3.5C3.22386 18 3 17.7761 3 17.5Z"
        fill={color}
      />
    </svg>
  )
})

export default AlignLeft
